import React from "react";
import {
  CharityContainer,
  CharityContent,
  CharityImg,
  CharityTitle,
} from "raffle-house-uikit/dist/cjs";
import { getCharityLogoUrl } from "../../helpers/getCharityLogoUrl";

import "./styles.scss";

export default function Charity() {
  const charityLogo = getCharityLogoUrl(process.env.REACT_APP_CHARITY_NAME);

  return (
    <div className="charity-block-wrap">
      
      <CharityContainer>
        
        <CharityTitle>
          Our charity partners
        </CharityTitle>
        <CharityContent type="single">
          <CharityImg
            image1={charityLogo}
            link="https://www.fundraisingregulator.org.uk/directory/raffle-house-ltd"
            iconSrc="https://www.fundraisingregulator.org.uk/fr-badge/7c26a59e-dca9-462a-8e9b-84b3c234f6f9/en/colour"
          />
        </CharityContent>
      </CharityContainer>
    </div>
  );
}
